/**
 * FeedbackButton - Persistent button to open feedback modal
 * 
 * Can be placed in header or as a floating button
 */

import { useState } from 'react'
import { Icon } from './Icon'
import { FeedbackModal } from './FeedbackModal'
import './FeedbackButton.css'

/**
 * @param {object} props
 * @param {string} [props.variant='header'] - 'header' | 'floating'
 * @param {string} [props.className] - Additional CSS class
 */
export function FeedbackButton({ variant = 'header', className = '' }) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        className={`feedback-button feedback-button--${variant} ${className}`}
        onClick={() => setIsModalOpen(true)}
        title="Send feedback"
        aria-label="Send feedback"
      >
        <Icon name="feedback" size={variant === 'floating' ? 20 : 16} />
        {variant === 'header' && (
          <span className="feedback-button__label">Feedback</span>
        )}
      </button>

      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  )
}

export default FeedbackButton
